module.exports = __webpack_public_path__ + "img/36.4f90495f.jpg";